import { Skeleton } from '@nexelem/components';

type FlatViewSkeletonProps = {
  rowsCount: number;
};

export const FlatViewSkeleton = ({ rowsCount }: FlatViewSkeletonProps) => (
  <div>
    {[...Array(rowsCount)].map((_, index) => (
      <div className="flex items-center gap-4 border-b border-border-secondary px-3 py-2" key={index}>
        <Skeleton className="size-7 rounded-full" />
        <div className="flex grow flex-col gap-1">
          <Skeleton className="h-4.5" />
          <Skeleton className="h-3.5 w-7/10" />
        </div>
        <Skeleton className="size-7" />
      </div>
    ))}
  </div>
);
